import { render } from "./Assignment.vue?vue&type=template&id=e5bddb58&scoped=true"
import script from "./Assignment.vue?vue&type=script&lang=js"
export * from "./Assignment.vue?vue&type=script&lang=js"

import "./Assignment.vue?vue&type=style&index=0&id=e5bddb58&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./Assignment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5bddb58"]])

export default __exports__